import { useState } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import CheckIcon from '@mui/icons-material/Check'
import Alert from '@mui/material/Alert'

import type { User } from '@/types'
import { useApproveUser } from '@/hooks/api/use-users'

function ApproveUser({
    user,
}: {
    user: User,
}) {

    const [requestInProgress, setRequestInProgress] = useState(false)
    const [error, setError] = useState<string | null>(null)
    const [success, setSuccess] = useState(false)

    const toggleActiveMutation = useApproveUser(user.id, {
        onSuccessCallback(data) {
            if(data) {
                setSuccess(true)
            }
        },
        onErrorCallback(errorMessage) {
            setError(errorMessage)
        },
        setRequestInProgress,
    })

    const handleApprove = () => {
        toggleActiveMutation.mutate()
    }

    return (
        <Box mt={1}>
            {success &&
                <Alert
                    severity="success"
                    sx={(theme) => ({
                        flexGrow: 1,
                        margin: theme.spacing(1, 0),
                    })}
                    onClose={() => setSuccess(false)}
                >
                    Uživatel úspěšně schválen.
                </Alert>
            }
            {error &&
                <Alert
                    severity="error"
                    sx={(theme) => ({
                        flexGrow: 1,
                        margin: theme.spacing(1, 0),
                    })}
                    onClose={() => setError(null)}
                >
                    {error}
                </Alert>
            }
            {!success && !error &&
                <Button
                    startIcon={<CheckIcon />}
                    onClick={() => handleApprove()}
                    color='terciary'
                    variant="outlined"
                    disabled={requestInProgress}
                >
                    Schválit uživatele
                </Button>
            }
        </Box>
    )
}

export default ApproveUser
